import { useEffect, useState } from "react";
import api, { fmtDateTime } from "@/lib/apiClient";
import AdminLayout from "@/layouts/AdminLayout";
import { amdenNav } from "@/lib/navConfig";
import { PageHeader, KpiCard } from "@/components/Common";
import { AlertTriangle } from "lucide-react";

export default function SystemLogs() {
  const [d, setD] = useState(null);
  const [audit, setAudit] = useState([]);
  useEffect(() => {
    api.get("/support/dashboard").then((r) => setD(r.data));
    api.get("/audit-logs", { params: { limit: 100 } }).then((r) => setAudit(r.data));
  }, []);
  return (
    <AdminLayout nav={amdenNav} title="System Logs">
      <PageHeader title="System Logs" subtitle="Failed logins, activity and errors" />
      {d && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <KpiCard testId="sl-failed" label="Accounts w/ Failed Logins" value={d.failed_logins.length} icon={AlertTriangle} accent />
          <KpiCard testId="sl-active" label="Active Users" value={d.active_users} />
          <KpiCard testId="sl-sessions" label="Support Sessions" value={d.support_sessions.length} />
          <KpiCard testId="sl-audit" label="Audit Events" value={d.audit_count} />
        </div>
      )}
      <div className="bg-white border border-zinc-200 rounded-md overflow-x-auto kqm-scroll">
        <div className="px-4 py-3 border-b border-zinc-100 text-xs font-bold uppercase tracking-wider text-zinc-500">Recent Activity</div>
        <table className="w-full text-sm">
          <tbody>
            {audit.map((r) => (
              <tr key={r.id} className="border-b border-zinc-50">
                <td className="p-3 num text-xs whitespace-nowrap">{fmtDateTime(r.timestamp)}</td>
                <td className="p-3">{r.user_name}</td>
                <td className="p-3"><span className="text-xs font-semibold bg-zinc-100 px-2 py-0.5 rounded">{r.action}</span></td>
                <td className="p-3 text-zinc-500">{r.entity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
